import { StreamType } from '../types';
import {
  InitializeActionParams,
  InitializeAction,
  FetchAction,
  FetchSuccessActionParams,
  FetchSuccessAction,
  FetchSuccessDedupedActionParams,
  FetchSuccessDedupeAction,
  InsertItemsAtOffsetAndSetCursorAction,
  InsertItemsAtOffsetAndSetCursorActionParams,
  FetchPreviousSuccessActionParams,
} from './types';
import { actionKey } from './constants';
import { createAction } from 'redux-actions';
import { FetchAllSuccessActionParams } from '../base/types';

export const STREAM__WITH_CURSOR__INITIALIZE = `${actionKey}__INITIALIZE`;
export const STREAM__WITH_CURSOR__SET_CURSOR = `${actionKey}__SET_CURSOR`;
export const STREAM__WITH_CURSOR__FETCH = `${actionKey}__FETCH`;
export const STREAM__WITH_CURSOR__FETCH_SUCCESS = `${actionKey}__FETCH_SUCCESS`;
export const STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE = `${actionKey}__FETCH_SUCCESS_DEDUPE`;
export const STREAM__WITH_CURSOR__INSERT_ITEMS = `${actionKey}__INSERT_ITEMS`;

export const initialize = ({
  cursor,
  prevCursor,
  ...baseInitializeParams
}: InitializeActionParams): InitializeAction => ({
  ...baseInitializeParams,
  type: STREAM__WITH_CURSOR__INITIALIZE,
  streamType: StreamType.WITH_CURSOR,
  cursor,
  prevCursor,
});

export const setCursor = (streamId: string, cursor: string) => ({
  type: STREAM__WITH_CURSOR__SET_CURSOR,
  streamId,
  cursor,
});

export const fetch = (streamId: string): FetchAction => ({
  type: STREAM__WITH_CURSOR__FETCH,
  streamId,
});

export const fetchAll = (streamId: string): FetchAction => ({
  type: STREAM__WITH_CURSOR__FETCH,
  streamId,
  all: true,
});

export const fetchSuccess = ({
  streamId,
  items,
  entities,
  hasMore,
  hasLess,
  total,
  cursor,
  prevCursor,
}: FetchSuccessActionParams): FetchSuccessAction => ({
  type: STREAM__WITH_CURSOR__FETCH_SUCCESS,
  streamId,
  items,
  entities,
  hasMore,
  hasLess,
  total,
  cursor,
  prevCursor,
});

export const fetchSuccessDeduped = (
  payload: FetchSuccessDedupedActionParams
): FetchSuccessDedupeAction => ({
  type: STREAM__WITH_CURSOR__FETCH_SUCCESS_DEDUPE,
  ...payload,
});

export const insertItemsAtOffsetAndSetCursor = ({
  streamId,
  items,
  offset,
  entities,
  newCursor,
}: InsertItemsAtOffsetAndSetCursorActionParams): InsertItemsAtOffsetAndSetCursorAction => ({
  type: STREAM__WITH_CURSOR__INSERT_ITEMS,
  streamId,
  items,
  offset,
  entities,
  newCursor,
});

export const fetchPrevious = createAction(
  `${actionKey}__FETCH_PREVIOUS`,
  (streamId: string) => ({ streamId })
);

export const fetchPreviousSuccess = createAction(
  `${actionKey}__FETCH_PREVIOUS_SUCCESS`,
  ({
    streamId,
    items,
    entities,
    hasLess,
    prevCursor,
    dedupeFunction,
  }: FetchPreviousSuccessActionParams) => ({
    streamId,
    items,
    entities,
    hasLess,
    prevCursor,
    dedupeFunction,
  })
);

export const fetchAllSuccess = createAction(
  `${actionKey}__FETCH_All_SUCCESS`,
  ({ streamId, items, entities }: FetchAllSuccessActionParams) => ({
    streamId,
    items,
    entities,
  })
);

export const emptyStream = createAction(
  `${actionKey}__EMPTY`,
  (streamId: string) => ({ streamId })
);
export const resetStream = createAction(
  `${actionKey}__RESET`,
  (streamId: string) => ({ streamId })
);

export {
  deleteItems,
  deleteStream,
  fetchFailure,
  replaceItem,
  markAsFetching,
} from '../base/actions';
